// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"adbbb60e","917":"50d69f47","967":"66be6909"}[chunkId] + ".chunk.css";
};